import services from './services';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import viewtestclass from '../components/viewtestclass/index.vue';
export default {
    mixins: [services],
    components: { viewtestclass },
    data() {
        return {
            isUpdate: false,
            testclass: false,
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '', //分页总数
            pageSizes: [10, 20, 50], //分页类型
            query: this.getQuery(), //查询条件
            childorderId: "",
            queryType: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "待审核", "TypeValue": "1" }, { "TypeName": "审核通过", "TypeValue": "6" }],
            queryDelivery: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "未发货", "TypeValue": "0" }, { "TypeName": "部分发货", "TypeValue": "1" }, { "TypeName": "全部发货", "TypeValue": "2" }],
        }
    },
    methods: {
        getQuery() {
            return cloneDeep({
                OrderCode: "",
                AgentName: "",
                c_name: "",
                OrderStatus: ""
            });
        },
        resetSearch() {
            this.query = this.getQuery();
            this.req_getList();
        },
        passcheck(item) {
            this.$confirm('是否确定通过审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.req_submitaudit(item.OrderId);
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.req_getList();
        }, //分页选定行
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.req_getList();
        }, //分页监听dd页面
        handleView: function(index, row) {
            this.testclass = true;
            this.isUpdate = false;
            this.childorderId = row.OrderId;
            this.$nextTick(function() {
                this.$refs.viewtestclass.req_getOrderData();
            });
        },
        handleUpdate(index, row) {
            this.testclass = true;
            this.childorderId = row.OrderId;
            this.isUpdate = true;
            this.$nextTick(() => {
                this.$refs.viewtestclass.req_getOrderData();
            });
        },
        showmypage() {
            this.$store.dispatch("getRouterName", "试课审核")
            this.testclass = false;
            this.req_getList();
        }
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        },
    },
    created() {
        this.req_getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/testClassAudit/vm.js